module.exports = __webpack_public_path__ + "static/media/cctv.2beaf436.svg";